var map = {
	"./account.svg": 243,
	"./add-wallets.svg": 890,
	"./analytics.svg": 137,
	"./api.svg": 249,
	"./arrow-left.svg": 207,
	"./bell.svg": 141,
	"./blue_plus.svg": 391,
	"./close.svg": 392,
	"./close_bg.svg": 18,
	"./cog.svg": 140,
	"./colomn.svg": 239,
	"./dep.svg": 393,
	"./dollor.svg": 394,
	"./help.svg": 268,
	"./home.svg": 395,
	"./icon-my-orders.svg": 229,
	"./icon-wallets.svg": 231,
	"./interface.svg": 251,
	"./like.svg": 124,
	"./logout.svg": 265,
	"./message.svg": 136,
	"./moon.svg": 233,
	"./nav_wallet.svg": 142,
	"./noun-1198083-cc.svg": 261,
	"./noun-540071-cc.svg": 255,
	"./noun-553134-cc.svg": 257,
	"./noun-993426-cc.svg": 259,
	"./plus.svg": 396,
	"./plus_big.svg": 143,
	"./raw_down.svg": 69,
	"./raw_up.svg": 125,
	"./reports.svg": 253,
	"./security.svg": 245,
	"./share.svg": 397,
	"./share2.svg": 126,
	"./signout.svg": 139,
	"./sun.svg": 232,
	"./tile.svg": 241,
	"./traders.svg": 138,
	"./tran.svg": 398,
	"./verifications.svg": 247,
	"./wallet.svg": 230,
	"./white_account.svg": 244,
	"./white_add_message.svg": 237,
	"./white_analytics.svg": 263,
	"./white_api.svg": 250,
	"./white_bell.svg": 271,
	"./white_bg-signout.svg": 267,
	"./white_close_bg.svg": 273,
	"./white_cog.svg": 270,
	"./white_colomn.svg": 240,
	"./white_help.svg": 269,
	"./white_interface.svg": 252,
	"./white_logout.svg": 266,
	"./white_nav_wallet.svg": 272,
	"./white_noun-1198083-cc.svg": 262,
	"./white_noun-540071-cc.svg": 256,
	"./white_noun-553134-cc.svg": 258,
	"./white_noun-993426-cc.svg": 260,
	"./white_plus_big.svg": 274,
	"./white_read.svg": 238,
	"./white_reports.svg": 254,
	"./white_security.svg": 246,
	"./white_tile.svg": 242,
	"./white_traders.svg": 264,
	"./white_verifications.svg": 248,
	"./white_wallet.svg": 234,
	"./white_wallet_1.svg": 235,
	"./white_wallet_add.svg": 236,
	"./wit.svg": 399,
	"./wtihe_cog.svg": 891
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 889;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 889
// module chunks = 0